import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import CheckBox from '@spark/ui-components/components/form/CheckBox';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

const formatCpf = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length !== 11) return value;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

const getStatusBadgeVariant = (value) => {
  const v = String(value || '').trim().toLowerCase();
  if (!v) return 'default';
  if (v.includes('enviado')) return 'success';
  if (v.includes('enviando')) return 'default';
  if (v.includes('erro')) return 'danger';
  return 'default';
};

export const getAnexosUploadColumns = (
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled,
  onVisualizar,
  onExcluir,
  disabledIds
) => {
  const columns = [
    {
      id: 'nomeOriginal',
      header: 'Nome Original',
      accessorKey: 'nomeOriginal',
      size: 40,
      enableSorting: true,
      cell: ({ getValue }) => {
        const value = getValue() || '';
        return (
          <span title={String(value)}>
            <TruncatedText value={value} maxLength={90} />
          </span>
        );
      }
    },
    {
      id: 'tipo',
      header: 'Tipo',
      accessorKey: 'tipo',
      size: 45,
      enableSorting: true,
      cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={24} />
    },
    {
      id: 'nomeMotorista',
      header: 'Nome Motorista',
      accessorKey: 'nomeMotorista',
      size: 70,
      enableSorting: true,
      cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={22} />
    },
    {
      id: 'cpfMotorista',
      header: 'CPF Motorista',
      accessorKey: 'cpfMotorista',
      size: 60,
      enableSorting: true,
      cell: ({ getValue }) => <TruncatedText value={formatCpf(getValue())} maxLength={22} />
    },
    {
      id: 'numeroContainer',
      header: 'Numero Container',
      accessorKey: 'numeroContainer',
      size: 60,
      enableSorting: true,
      cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={18} />
    },
    {
      id: 'status',
      header: 'Status',
      accessorKey: 'status',
      size: 45,
      enableSorting: true,
      cell: ({ getValue }) => (
        <TableBadge
          label={String(getValue() || '')}
          variant={getStatusBadgeVariant(getValue())}
          size="sm"
        />
      )
    },
    {
      id: 'erro',
      header: 'Erro',
      accessorKey: 'erro',
      size: 90,
      enableSorting: false,
      cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={40} />
    },
  ];

  if (onToggleSelect || onVisualizar || onExcluir) {
    const headerContent = (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {onToggleSelectAll && (
          <Tooltip dir="top" text={allPageSelected ? 'Remover selecao da pagina' : 'Selecionar pagina'}>
            <span className="d-inline-flex align-items-center">
              <CheckBox
                name="select-all-anexos-upload"
                checked={!!allPageSelected}
                disabled={!!selectAllDisabled}
                label=""
                onChange={(event) => {
                  event.stopPropagation();
                  onToggleSelectAll();
                }}
                onClick={(event) => event.stopPropagation()}
              />
            </span>
          </Tooltip>
        )}
        <span>Ações</span>
      </div>
    );

    columns.unshift({
      id: 'acoes',
      header: () => headerContent,
      accessorKey: 'id',
      size: 50,
      minSize: 50,
      enableHiding: false,
      enablePinning: true,
      enableSorting: false,
      cell: ({ row }) => (
        <div style={{ display: 'inline-flex', gap: 8, alignItems: 'center', flexWrap: 'nowrap', minWidth: 72 }}>
          {onToggleSelect && (
            <Tooltip dir="top" text={selectedIds?.includes(row.original.id) ? 'Remover selecao' : 'Selecionar'}>
              <span className="d-inline-flex align-items-center">
                <CheckBox
                  name={`select-${row.original.id}`}
                  checked={selectedIds?.includes(row.original.id)}
                  disabled={disabledIds?.has(row.original.id)}
                  label=""
                  onChange={(event) => {
                    event.stopPropagation();
                    onToggleSelect(row.original);
                  }}
                  onClick={(event) => event.stopPropagation()}
                />
              </span>
            </Tooltip>
          )}
          {onVisualizar && (
            <Tooltip dir="top" text="Visualizar">
              <span className="d-inline-block">
                <ButtonWithLoading
                  variant="outline-primary"
                  size="sm"
                  loading={false}
                  style={{ minWidth: 'auto' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onVisualizar(row.original);
                  }}
                >
                  <Icon name="search" size={14} />
                </ButtonWithLoading>
              </span>
            </Tooltip>
          )}
          {onExcluir && (
            <Tooltip dir="top" text="Excluir">
              <span className="d-inline-block">
                <ButtonWithLoading
                  variant="outline-danger"
                  size="sm"
                  loading={false}
                  style={{ minWidth: 'auto' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onExcluir(row.original);
                  }}
                >
                  <Icon name="delete" size={14} />
                </ButtonWithLoading>
              </span>
            </Tooltip>
          )}
        </div>
      )
    });
  }

  return columns;
};
